import { render, staticRenderFns } from "./UsersOverview.vue?vue&type=template&id=6a5a3b28&scoped=true&"
import script from "./UsersOverview.vue?vue&type=script&lang=js&"
export * from "./UsersOverview.vue?vue&type=script&lang=js&"
import style0 from "./UsersOverview.vue?vue&type=style&index=0&id=6a5a3b28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a3b28",
  null
  
)

export default component.exports